import { Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import DocumenteListHr from './DocumenteListHr';
import SpecificComponent from '../../commons/SpecificComponent';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import AlertNew from '../../commons/dialogs/AlertNew';
import LocalStorage from '../../providers/LocalStorage';


export default class DocumenteHr extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

            angajati: [],
            departamente: [],
            departament: '-1',
            documenteAll: true,
            searchAngajat: '',
            angajat: {},
            docs: [],
            alertView:false

        }
    }

    componentDidMount() {
        this.access()
        this.getData()
    }

    ws = new Ws()
    u = new Utils()
    ls = new LocalStorage().GetUserData()

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }


    getData = async (depart = null) => {
        let _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
        on a.id = ad.id_angajat where 1 = 1`, {
            p1: 'Candidat'
        })

        let _departamente = this.ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, {
            p1: 1
        })

        let _documente = this.ws.customSelect('select * from angajati_documente where isnull(sters,0) != 1', {
            p1: 1
        })



        let [angajati, departamente, documente] = await Promise.all([_angajati, _departamente, _documente])
        console.log('angajati :>> ', angajati);
        console.log('departamente :>> ', departamente);
        console.log('documente :>> ', documente);

        if (angajati.Succes && departamente.Succes && documente.Succes) {

            let ang = [...angajati.Content]
            let dep = [...departamente.Content]
            let docs = [...documente.Content]

            for (let i = 0, n = ang.length; i < n; i++) {
                let idxDep = dep.findIndex(d => Number(d.id) === Number(ang[i].id_departament))

                ang[i]['documente_all'] = docs.filter(dd => Number(dd.id_angajat) === Number(ang[i].id)).length


                ang[i]['documente_jpg'] = docs.filter(dd => dd.nume.toLowerCase().indexOf('jpg') !== -1 && Number(dd.id_angajat) === Number(ang[i].id)).length
                ang[i]['documente_word'] = docs.filter(dd => dd.nume.toLowerCase().indexOf('docx') !== -1 && Number(dd.id_angajat) === Number(ang[i].id)).length
                ang[i]['documente_pdf'] = docs.filter(dd => dd.nume.toLowerCase().indexOf('pdf') !== -1 && Number(dd.id_angajat) === Number(ang[i].id)).length




                if (idxDep !== -1) {

                    ang[i]['nume_departament'] = dep[idxDep].nume
                }
            }

            console.log('ang :>> ', ang);

            console.log('dep :>> ', dep);

            if (depart) {
                ang = ang.filter(aa => Number(aa.id_departament) === Number(depart))
            }

            this.setState({
                angajati: ang,
                departamente: dep,
                searchAngajat: '',
                docs: []
            })


        }




    }

    searchForAngajat = async () => {



        let _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
        on a.id = ad.id_angajat where nume = @p1`, {
            p1: this.state.searchAngajat
        })

        let _departamente = this.ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, {
            p1: 1
        })



        let [angajati, departamente] = await Promise.all([_angajati, _departamente])

        if (angajati.Succes && departamente.Succes) {



            let ang = angajati.Content.length > 0 ? { ...angajati.Content[0] } : {}
            let dep = [...departamente.Content]



            if (angajati.Content.length > 0) {

                let documente = await this.ws.customSelect('select * from angajati_documente where isnull(sters,0) != 1 and id_angajat = @p1 ', {
                    p1: ang.id
                })

                if (documente.Succes) {

                    let docs = [...documente.Content]

                    let idxDep = dep.findIndex(d => Number(d.id) === Number(ang.id_departament))

                    if (idxDep !== -1) {

                        ang['nume_departament'] = dep[idxDep].nume
                    }


                    for (let i = 0, n = docs.length; i < n; i++) {

                        docs[i]['angajat'] = ang

                        docs[i]['type'] = docs[i]['nume'].substring(docs[i]['nume'].indexOf("."));
                    }


                    console.log('docs :>> ', docs);


                    this.setState({
                        angajat: ang,
                        angajati: [],
                        docs: docs
                    })

                }






            }
        }
    }


    changeDepartament = async (ev) => {

        let val = ev.target.value
        this.setState({ departament: val }, async () => {

            if (Number(val) === -1) {
                this.getData()
            } else {
                this.getData(val)
            }

        })
    }

    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={' '} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />
                <Grid style={{ maxWidth: 1300, margin: 'auto', marginBottom: 40 }} container >

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.pontaje.documenteResurseUmane} </h1>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      
                            <DocumenteListHr
                                departament={this.state.departament}
                                departamente={this.state.departamente}
                                angajati={this.state.angajati.filter(aa => aa.statusul !== 'Candidat')}
                                changeDepartament={this.changeDepartament}
                                history={this.props.history}
                                searchAngajat={this.state.searchAngajat}
                                changeSearchData={(ev) => { this.setState({ searchAngajat: ev.target.value }) }}
                                searchForAngajat={this.searchForAngajat}
                                documenteAll={this.state.documenteAll}
                                angajat={this.state.angajat}
                                docs={this.state.docs}
                                getData={()=>{this.getData()}}
                            />
                        


                    </Grid>
                </Grid>

            </div>
        );
    }
}